class Incrementer {
  constructor(options = {}) {
    this.config = {
      module: document.querySelectorAll('[data-module="incrementer"]'),
      ...options
    };
  }

  init() {
    const { module } = this.config;

    module.forEach(incrementer => {
      const buttonMinus = incrementer.querySelector('[data-type="minus"]');
      const buttonPlus = incrementer.querySelector('[data-type="plus"]');
      const quantityElement = incrementer.querySelector('input[name="quantity"]');

      if (buttonMinus == null && buttonPlus == null) {
        return;
      }

      if (!quantityElement.dataset.activeListener) {
        quantityElement.addEventListener('change', () => {
          if (quantityElement.value <= 0) {
            quantityElement.value = 1;
          }

          if (quantityElement.max && quantityElement.value > quantityElement.max) {
            quantityElement.value = quantityElement.max;
          }
        });

        quantityElement.addEventListener('input', () => {
          if (quantityElement.max && quantityElement.value > quantityElement.max) {
            quantityElement.value = quantityElement.max;
          }
        });
        quantityElement.dataset.activeListener = true;
      }

      if (!buttonMinus.dataset.activeListener) {
        buttonMinus.addEventListener('click', () => {
          if (parseInt(quantityElement.value, 10) > 1) {
            quantityElement.value = parseInt(quantityElement.value, 10) - 1;
          }
        });
        buttonMinus.dataset.activeListener = true;
      }

      if (!buttonPlus.dataset.activeListener) {
        buttonPlus.addEventListener('click', () => {
          if (
            quantityElement.max &&
            parseInt(quantityElement.value, 10) >= parseInt(quantityElement.max, 10)
          )
            return;
          quantityElement.value = parseInt(quantityElement.value, 10) + 1;
        });
        buttonPlus.dataset.activeListener = true;
      }
    });
  }
}

export default Incrementer;
